import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { RubriqueDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { UtilisateurConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurConnecteDto";
import { SocieteDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { ServicesFactoryInstance } from "./ServicesFactory";
import { EventBus } from "./EventBus";
import moment from "moment";
import { CommuneDto } from "../../dto/GenApi.iNotPaie.Dto/CommuneDto";
import { OuvertureExerciceMessageDto } from "../../dto/GenApi.iNotPaie.Dto/OuvertureExerciceMessageDto";
import iNotPaieStorageKeys, { LocalStorageService } from "../Controls/LocalStorageService";
import EventConstants, { RoleConstants } from "./EventConstants";
import { EtatSaisieMessageDto } from "../../dto/GenApi.iNotPaie.Dto/EtatSaisieMessageDto";
import { ClotureExerciceMessageDto } from "../../dto/GenApi.iNotPaie.Dto/ClotureExerciceMessageDto";
import { SalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { KeyValue } from "../calendrier/calendrier.model";
import { NameMonth } from "../../shared/models/name-month";
import { EtatAbsencesEnum } from "../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ActionAbsencesEnum } from "../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { UtilisateurOrigineEnum } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurOrigineEnum";
import { RegleSequenceCalculDto } from "../../dto/GenApi.iNotPaie.Dto/RegleSequenceCalculDto";

export class Parametres {
	public societeCourante?: SocieteDto = undefined;
	public utilisateurCourant?: UtilisateurConnecteDto = undefined;
	public envType?: string = undefined;
	public isPst = false;
	public eMailPST?: string = undefined;
	//* * Les listes des parametres **//
	private listeReglesSeqencesCalcul: RegleSequenceCalculDto[] = [];
	public listeArrondis: ParametreDto[] = [];
	public listeOperateurs: ParametreDto[] = [];
	public listeConventionCollectives: ParametreDto[] = [];
	public listePays: ParametreDto[] = [];
	public listeClassifications: ParametreDto[] = [];
	public listeCivilite: ParametreDto[] = [];
	public listeQualifications: ParametreDto[] = [];
	public listeCodeInsees: ParametreDto[] = [];
	public listeDureeContrats: ParametreDto[] = [];
	public listeNatureContrats: ParametreDto[] = [];
	public listeTypeContrats: ParametreDto[] = [];
	public listeRemunerations: ParametreDto[] = [];
	public listeMaladieRetraites: ParametreDto[] = [];
	public listeRegimes: ParametreDto[] = [];
	public listeTransports: ParametreDto[] = [];
	public listeGestionConges: ParametreDto[] = [];
	public listeCaisseComplementaires: ParametreDto[] = [];
	public listePrevoyances: ParametreDto[] = [];
	public listeMutuelles: ParametreDto[] = [];
	public listePoints: ParametreDto[] = [];
	public listeTypeAbsences: ParametreDto[] = [];
	public listeMotifReprises: ParametreDto[] = [];
	public listeTypesMajoration: ParametreDto[] = [];
	public listeRubriques: RubriqueDto[] = [];

	public listeMois = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
	public listeRacineCodesPostauxDomTom = ["97", "98"];
	public listeRacineCodesPostauxAlsaceMoselle = ["67", "68", "57"];
	public listeMotifsPourDateNotificationRuptureObligatoire = ["11", "12", "14", "15", "20", "25", "34", "35", "36", "37", "58", "59", "82", "83", "87", "88", "89", "95", "96", "97", "117"];

	public listeMoisKeyValue: KeyValue[] = [
    	{
    		key: 0,
    		value: NameMonth.Janvier
    	},
    	{
    		key: 1,
    		value: NameMonth.Fevrier
    	},
    	{
    		key: 2,
    		value: NameMonth.Mars
    	},
    	{
    		key: 3,
    		value: NameMonth.Avril
    	},
    	{
    		key: 4,
    		value: NameMonth.Mai
    	},
    	{
    		key: 5,
    		value: NameMonth.Juin
    	},
    	{
    		key: 6,
    		value: NameMonth.Juillet
    	},
    	{
    		key: 7,
    		value: NameMonth.Aout
    	},
    	{
    		key: 8,
    		value: NameMonth.Septembre
    	},
    	{
    		key: 9,
    		value: NameMonth.Octobre
    	},
    	{
    		key: 10,
    		value: NameMonth.Novembre
    	},
    	{
    		key: 11,
    		value: NameMonth.Decembre
    	}
	];

	public listeJours = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
	public listeJoursMini = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

	public allCommune: CommuneDto[] = [];
	public listeParametres: ParametreDto[] = [];
	public estModeManager = false;
	public modeBloque = false;

	public constructor() {
    	EventBus.$on("OuvertureExerciceMessageDto", data => {
    		const message = data as OuvertureExerciceMessageDto;
    		if (this.societeCourante != undefined && this.societeCourante.Code == message.CodeSociete) {
    			this.societeCourante.PeriodeActive = moment.utc(message.PeriodeActive).toDate();
    			this.societeCourante.EtatSaisie = message.EtatSaisie;
    			EventBus.$emit(EventConstants.ETAT_SAISIE_CHANGED, message.EtatSaisie);
    		}
    	});
    	EventBus.$on("ClotureExerciceMessageDto", data => {
    		const message = data as ClotureExerciceMessageDto;
    		if (this.societeCourante != undefined && this.societeCourante.Code == message.CodeSociete) {
    			this.societeCourante.PeriodeActive = undefined;
    			this.societeCourante.EtatSaisie = message.EtatSaisie;
    			EventBus.$emit(EventConstants.ETAT_SAISIE_CHANGED, message.EtatSaisie);
    		}
    	});
    	EventBus.$on("EtatSaisieMessageDto", data => {
    		const message = data as EtatSaisieMessageDto;
    		if (this.societeCourante != undefined && this.societeCourante.Code == message.CodeSociete) {
    			this.societeCourante.EtatSaisie = message.EtatSaisie;
    			EventBus.$emit(EventConstants.ETAT_SAISIE_CHANGED, message.EtatSaisie);
    		}
    	});
	}

	public setSocieteCourante(societe?: SocieteDto): void {
    	this.societeCourante = societe;

    	if (this.societeCourante != undefined && this.societeCourante.Code != undefined) {
    		LocalStorageService.set(iNotPaieStorageKeys.USER_SOCIETE, this.societeCourante.Code);
    	}

    	if (this.societeCourante != undefined && this.societeCourante.PeriodeActive != undefined) {
    		this.societeCourante.PeriodeActive = moment.utc(this.societeCourante.PeriodeActive).toDate();
    	}

    	EventBus.$emit(EventConstants.SOCIETE_CHANGED, this.societeCourante);

    	EventBus.$emit(EventConstants.ETAT_SAISIE_CHANGED, etat => {
    		if (this.societeCourante != undefined) {
    			this.societeCourante.EtatSaisie = etat;
    		}
    	});
    	setTimeout(this.refreshAllList, 500);
	}

	public setUtilisateurCourant(utilisateur: UtilisateurConnecteDto): void {
    	this.utilisateurCourant = utilisateur;
    	EventBus.$emit(EventConstants.UTILISATEUR_CHANGED, utilisateur);
	}

	public setPstStatus(isPst: boolean): void {
    	this.isPst = isPst;
	}

	public setEnvType(envType: string | undefined): void {
		this.envType = envType;
	}

	public seteMailPST(eMailPST: string | undefined): void {
		this.eMailPST = eMailPST;
	}

	public userIsAuthorized(roles: string[]): boolean {
    	let isAuthorized = false;
    	roles.forEach((x) => {
    		isAuthorized = isAuthorized || this.userHasRole(x);
    	});

    	return isAuthorized || this.userHasRole(RoleConstants.Administrateur);
	}

	public userIsCombinedAuthorized(roles: string[]): boolean {
		const isAuthorized: boolean[] = [];
		roles.forEach((x) => {
			isAuthorized.push(this.userHasRole(x));
		});

		return isAuthorized.every((elt) => elt);
	}

	public userHasRole(role: string): boolean {
    	if (this.utilisateurCourant == undefined) {
    		return false;
    	}
    	if (this.utilisateurCourant.Roles == undefined) {
    		return false;
    	}

    	return this.utilisateurCourant.Roles != undefined && this.utilisateurCourant.Roles.filter(r => r == role).length > 0;
	}

	public listesLoaded = false;
	public allListesLoaded = 0;

	public checkAllLoaded(): void {
    	this.allListesLoaded -= 1;
    	if (this.allListesLoaded == 0) {
    		EventBus.$emit(EventConstants.ALL_LISTES_LOADED, true);
    	}
	}

	/**
	 * Méthode pour vérifier si toutes les listes sont chargées
	 * @returns boolean : true si toutes les listes sont chargées, false sinon
	 */
	public checkListLoaded(): boolean {
		// Liste des listes à vérifier sauf listeMutuelles et listePrevoyances (car elles sont vides de base)
		const listToCheck = [
			this.listeArrondis,
			this.listeOperateurs,
			this.listeConventionCollectives,
			this.listePays,
			this.listeClassifications,
			this.listeCivilite,
			this.listeQualifications,
			this.listeCodeInsees,
			this.listeDureeContrats,
			this.listeNatureContrats,
			this.listeTypeContrats,
			this.listeRemunerations,
			this.listeMaladieRetraites,
			this.listeRegimes,
			this.listeTransports,
			this.listeGestionConges,
			this.listeCaisseComplementaires,
			this.listePoints,
			this.listeTypeAbsences,
			this.listeMotifReprises,
			this.listeTypesMajoration,
			this.listeRubriques
		];

		let remainingCount = listToCheck.length;

		for (const list of listToCheck) {
			if (list.length) {
				remainingCount--;
			}
		}

		return remainingCount == 0;
	}

	public refreshAllList(): undefined {
    	if (this.listesLoaded) {
    		return;
    	}

		if (ServicesFactoryInstance == undefined || ServicesFactoryInstance.ParametresService == undefined) {
			return;
		}
		this.listesLoaded = true;
		ParametresInstance.refreshListeRubriques();
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getArrondis(data => {
			ParametresInstance.listeArrondis = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getOperateurs(data => {
			ParametresInstance.listeOperateurs = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.refreshListeTypesConges();
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getMotifReprises(data => {
			ParametresInstance.listeMotifReprises = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.refreshListeConventions();
		ParametresInstance.refreshListeQualifications();
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getPays(data => {
			ParametresInstance.listePays = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getClassifications(false, data => {
			ParametresInstance.listeClassifications = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getCodeInsees(data => {
			ParametresInstance.listeCodeInsees = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getDureeContrats(data => {
			ParametresInstance.listeDureeContrats = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getNatureContrats(data => {
			ParametresInstance.listeNatureContrats = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getTypeContrats(data => {
			ParametresInstance.listeTypeContrats = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getMaladieRetraites(data => {
			ParametresInstance.listeMaladieRetraites = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getRegimes(data => {
			ParametresInstance.listeRegimes = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.refreshListeRemunerations();
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getTransports(data => {
			ParametresInstance.listeTransports = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getGestionConges(data => {
			ParametresInstance.listeGestionConges = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getCaisseComplementaires(data => {
			ParametresInstance.listeCaisseComplementaires = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getPrevoyances(data => {
			ParametresInstance.listePrevoyances = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getMutuelles(data => {
			ParametresInstance.listeMutuelles = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.CommunesService.getCommunes("", data => {
			ParametresInstance.allCommune = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getListePoints(data => {
			ParametresInstance.listePoints = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getCivilites(data => {
			ParametresInstance.listeCivilite = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getListeTypesMajoration(data => {
			ParametresInstance.listeTypesMajoration = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
	}

	public async getListeReglesSequencesCalculAsync(): Promise<RegleSequenceCalculDto[]> {
		if (!ParametresInstance.listeReglesSeqencesCalcul || ParametresInstance.listeReglesSeqencesCalcul.length === 0) {
			await ServicesFactoryInstance.RegleSequenceCalculService.getListeReglesSequencesCalculAsync(data => {
				ParametresInstance.listeReglesSeqencesCalcul = data;
			});
		}

		return ParametresInstance.listeReglesSeqencesCalcul;
	}

	public refreshListeTypesConges(): void {
    	ParametresInstance.allListesLoaded += 1;
    	ServicesFactoryInstance.ParametresService.getTypeConges(data => {
			ParametresInstance.listeTypeAbsences = data;
			if (ParametresInstance.listeTypeAbsences != undefined) {
				ParametresInstance.listeTypeAbsences.forEach(t => t.Libelle = t.Libelle?.toUpperCase());
			}
    		ParametresInstance.checkAllLoaded();
    	}, () => ParametresInstance.checkAllLoaded());
	}

	public refreshListeRubriques(): void {
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.RubriquesService.getRubriquesNonArchivee("", data => {
			ParametresInstance.listeRubriques = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
	}

	public refreshListeQualifications(): void {
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getQualifications(false, data => {
			ParametresInstance.listeQualifications = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
	}

	public refreshListeConventions(): void {
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getConventionsCollectives(data => {
			ParametresInstance.listeConventionCollectives = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
	}

	public refreshListeRemunerations(): void {
		ParametresInstance.allListesLoaded += 1;
		ServicesFactoryInstance.ParametresService.getRemunerations(data => {
			ParametresInstance.listeRemunerations = data;
			ParametresInstance.checkAllLoaded();
		}, () => ParametresInstance.checkAllLoaded());
	}

	public getLibelleEtatAbsence(etat: EtatAbsencesEnum): string {
    	let libelle = "en état inconnu";

		if (etat == EtatAbsencesEnum.EnAttenteValidationGestionnaire) {
			libelle = "en attente de validation par un gestionnaire de Paie";
		} else if (etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1) {
			libelle = "en attente de validation par un responsable niveau 1";
		} else if (etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2) {
			libelle = "en attente de validation par un responsable niveau 2";
		} else if (etat == EtatAbsencesEnum.Valide) {
			libelle = "validée";
		} else if (etat == EtatAbsencesEnum.Calcule) {
			libelle = "calculée dans le bulletin du mois";
		} else if (etat == EtatAbsencesEnum.Cloture) {
			libelle = "traîtée dans un exercice précédent";
		} else if (etat == EtatAbsencesEnum.Annule) {
			libelle = "annulée";
		} else if (etat == EtatAbsencesEnum.Refuse) {
			libelle = "refusée";
		} else if (etat == EtatAbsencesEnum.EnAttenteAnnulationGestionnaire) {
			libelle = "en attente d'annulation par un gestionnaire de Paie";
		} else if (etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1) {
			libelle = "en attente d'annulation par un responsable niveau 1";
		} else if (etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2) {
			libelle = "en attente d'annulation par un responsable niveau 2";
		}

    	return libelle;
	}

	public getLibelleActionAbsence(action: ActionAbsencesEnum): string {
    	let libelle = "";

    	if (action == ActionAbsencesEnum.ValiderAbsenceParGestionnaire ||
            action == ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_1 ||
            action == ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_2) {
    		libelle = "Validation d'une absence";
    	} else if (action == ActionAbsencesEnum.DemanderAnnulerAbsenceParSalarie) {
    		libelle = "Demande d'annulation d'absence";
    	} else if (action == ActionAbsencesEnum.AnnulerAbsenceParGestionnaire ||
            action == ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_1 ||
            action == ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_2) {
    		libelle = "Annulation d'absence";
    	} else if (action == ActionAbsencesEnum.RefuserAbsenceParGestionnaire ||
            action == ActionAbsencesEnum.RefuserAbsenceParResponsable) {
    		libelle = "Refus d'absence";
    	} else if (action == ActionAbsencesEnum.RefuserAnnulationAbsenceParResponsable) {
    		libelle = "Refus d'absence";
    	} else if (action == ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParSalarie ||
            action == ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParGestionnaire) {
    		libelle = "Annuler la demande d'annulation d'absence";
    	}

    	return libelle;
	}

	public getLibelleOrigineUtilisateur(origine: UtilisateurOrigineEnum): string {
    	let libelle = "Origine inconnue";
    	if (origine == UtilisateurOrigineEnum.Salarie) {
    		libelle = "Salarié";
    	} else if (origine == UtilisateurOrigineEnum.UtilisateurExterne) {
    		libelle = "Non salarié";
    	}

    	return libelle;
	}

	public estSocieteAlsaceMoselle(): boolean {
		if (this.societeCourante == null || this.societeCourante.CodePostal == null || this.societeCourante.CodePostal.length != 5) {
			return false;
		}

		const racineCodePostal = this.societeCourante.CodePostal.substring(0, 2);

		return this.listeRacineCodesPostauxAlsaceMoselle.filter(r => r == racineCodePostal).length > 0;
	}

	public estSocieteDomTom(): boolean {
		if (this.societeCourante == null || this.societeCourante.CodePostal == null || this.societeCourante.CodePostal.length != 5) {
			return false;
		}
		const racineCodePostal = this.societeCourante.CodePostal.substring(0, 2);

		return this.listeRacineCodesPostauxDomTom.filter(r => r == racineCodePostal).length > 0;
	}
}

export const ParametresInstance: Parametres = new Parametres();




// WEBPACK FOOTER //
// ./src/components/Controls/Parameters.ts